import { httpClient } from '../lib/httpClient';
import type { DisciplinesResponse } from '../interfaces/apiInterfaces/disciplines';

export interface DisciplinesQueryParams {
  page_number?: number;
  page_size?: number;
}

export async function fetchDisciplines(
  params?: DisciplinesQueryParams
): Promise<DisciplinesResponse> {
  const response = await httpClient.get<DisciplinesResponse>('/v1/disciplines', {
    params: params ?? { page_number: 1, page_size: 200 },
  });
  return response.data;
}
